import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Doca } from 'src/class/doca';
import { newUsuario } from 'src/class/usuario';
import { CepService } from 'src/services/cep.service';
import { DocaService } from 'src/services/component/doca.service';
import { ContadorIndexService } from 'src/services/contador-index.service';
import { DataService } from 'src/services/data.service';
import { SiglaService } from 'src/services/siglaService.service';
import { ToastService } from 'src/services/toast.service';
import { TranslateWordService } from 'src/services/translate-word.service';
import { UsuariosService } from 'src/services/usuarios.services';
import { ValidatorService } from 'src/services/validator.service';

declare var bootstrap: any;

@Component({
  selector: 'app-criar-doca',
  templateUrl: './criar-doca.component.html',
  styleUrls: ['./criar-doca.component.css']
})
export class CriarDocaComponent {

  @ViewChild('alertDocaModal', { static: false }) alertDocaModal!: ElementRef;

  usr_id: string = "";
  usr_tipo: string = "";
  usr_token: string = "";

  usr_obj: any = [];

  usr_new = new newUsuario;

  doca: Doca = new Doca();
  docas: Doca[] = [];
  empresaSigla: any | undefined;

  constructor(
    private router: Router,
    private usuarios: UsuariosService,
    private toast: ToastService,
    private validatorService: ValidatorService,
    private cepService: CepService,
    private translateWord: TranslateWordService,
    private contadorIndexService: ContadorIndexService,
    private docaService: DocaService,
    private route: ActivatedRoute,
    private siglaService: SiglaService
  ){
    // Alimenta o serviço com a empresaSigla
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.route.params.subscribe(params => {
          this.empresaSigla = params['empresaSigla'];
          this.siglaService.setEmpresaSigla(this.empresaSigla?.toString());
        });
      }
    });
  }

  async ngOnInit() {
    try{
      const usr = JSON.parse(localStorage.getItem('user')!);
      // this.usr_id = usr.Id;
      // this.usr_tipo = usr.Tipo;
      // this.usr_token = usr.Token;
      this.usr_id = "1";
      this.usr_tipo = "M";
      this.usr_token = "usr.Token";
      if(this.usr_tipo != "M" && this.usr_tipo != "A"){
        this.router.navigate(['/home']);
      }
    }catch{
      this.router.navigate(['/home']);
    }
    // Agora você pode usar o ID como quiser

  }

  routerLink(rota: string, id: any = null){
    if(id != null){
      this.router.navigate([`${this.empresaSigla}/${rota}`, id]);
    }else{
      this.router.navigate([`${this.empresaSigla}/${rota}`]);
    }
  }

  async criarDoca(){
    this.doca.nome.status = this.validatorService.criarValidacao(this.doca.nome.valor, this.doca.nome.validacoesCustomizadas);
    this.doca.descricao.status = this.validatorService.criarValidacao(this.doca.descricao.valor, this.doca.descricao.validacoesCustomizadas);

    if(this.doca.nome.status.invalid ||
      this.doca.descricao.status.invalid
    ){
      this.abrirModal(this.alertDocaModal.nativeElement);
    }else{

      this.doca.id = await this.contadorIndexService.contadorIndex();
      let new_doca  = new Doca();
      new_doca = this.doca;

      new_doca.criado = new Date();
      new_doca.atualizado = new Date();

      const doca = JSON.stringify(new_doca);
      const res = await this.docaService.criarDoca(JSON.parse(doca), this.empresaSigla)

      // this.showSuccess("Doca criado com sucesso");
      this.doca = new Doca();
      this.router.navigate([`${this.empresaSigla}/docas`]);
    }
  }

  abrirModal(event: any) {
    // Ativar o modal usando a biblioteca do Bootstrap
    const modal = new bootstrap.Modal(event);
    modal.show();
  }

  private showSuccess(msg: string){
    this.toast.showToast('<i class="bi bi-check-circle-fill " style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'success');
  }

  private showError(msg: string){
    this.toast.showToast('<i class="bi bi-x-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'danger');
  }

  private showInfo(msg: string) {
    this.toast.showToast('<i class="bi bi-info-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'info');
  }
}
